'use client';

import { FC, useId } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from './types';

const MoneliqLogoIcon: FC<SVGIconType> = ({ color, size = 120 }) => {
  const uid = useId();

  const gradientId = `moneliq-gradient-${uid.replace(/:/g, '')}`;

  const colorClasses = css({
    color: color || 'rgba(0, 0, 0, 1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  return (
    <span data-testid="moneliq-logo-icon" className={colorClasses}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        viewBox="0 0 85 18"
        fill="none"
      >
        <defs>
          <linearGradient
            id={gradientId}
            x1="0.07"
            y1="0.13"
            x2="0.95"
            y2="0.91"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#000" />
            <stop offset="0.5" stopColor="#000" />
            <stop offset="1" stopColor="#000" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M68.2219 12.9293H66.1804V0.165657H68.2219V12.9293Z"
          fill="#000"
        />
        <path
          d="M33.1916 2.24843C33.1916 2.18167 33.2322 2.10157 33.2727 2.04816C33.3268 1.99476 33.3809 1.95471 33.462 1.94135C33.5296 1.928 33.6107 1.94135 33.6783 1.96806C33.7459 1.99476 33.8 2.04816 33.8406 2.11492L38.3968 12.916H42.1824V0.165657H40.2491V12.3686L35.5982 1.40731C35.4359 0.993426 35.1385 0.632946 34.7735 0.392626C34.3949 0.138955 33.9623 0.0054437 33.5026 0.0054437C33.0429 0.0054437 32.3128 0.245764 31.8937 0.659648C31.4611 1.08688 31.2312 1.66098 31.2312 2.24843V12.9293H33.1916V2.24843Z"
          fill="#000"
        />
        <path
          d="M58.2171 10.9667C58.1225 10.9267 58.0279 10.8732 57.9603 10.7931C57.8791 10.713 57.8251 10.6329 57.7845 10.5261C57.7439 10.4327 57.7304 10.3259 57.7304 10.219V0.165657H55.7971V10.219C55.7971 10.5795 55.8647 10.9267 55.9999 11.2604C56.1351 11.5942 56.3379 11.8879 56.5947 12.1416C56.8516 12.3953 57.1491 12.5955 57.4871 12.7291C57.8251 12.8626 58.1766 12.9293 58.5416 12.9293H64.3687V11.0201C64.3687 11.0201 58.3253 11.0201 58.2307 10.9667H58.2171Z"
          fill="#000"
        />
        <path
          d="M53.2418 2.11492V0.165657H44.6701V10.219C44.6701 10.94 44.954 11.6209 45.4678 12.1283C45.9815 12.6356 46.6846 12.916 47.4011 12.916H53.2147V11.0068H47.4011C47.1848 11.0068 46.982 10.9267 46.8333 10.7798C46.6846 10.6329 46.5899 10.4327 46.5899 10.219V7.49541H53.2283V5.58621H46.5899V2.11492H53.2418Z"
          fill="#000"
        />
        <path
          d="M22.7677 13.1029C21.4563 13.1029 20.1719 12.7157 19.0767 12.0081C17.9816 11.2871 17.1299 10.2591 16.6296 9.07085C16.1294 7.86925 15.9942 6.54749 16.2511 5.27913C16.5079 4.01078 17.1434 2.83588 18.0627 1.91465C18.9956 0.993426 20.1719 0.379275 21.4698 0.125604C22.7542 -0.128067 24.0927 0.0054437 25.3095 0.499435C26.5263 0.993426 27.5538 1.83455 28.2839 2.91599C29.0139 3.99743 29.406 5.26578 29.3925 6.56084C29.3925 8.29648 28.6895 9.96537 27.4456 11.1803C26.2018 12.4086 24.5118 13.1029 22.7677 13.1029ZM22.7677 1.9013C21.8348 1.9013 20.929 2.16832 20.1448 2.67567C19.3742 3.18301 18.7658 3.91732 18.4007 4.75844C18.0357 5.61291 17.9411 6.54749 18.1303 7.44201C18.3061 8.34989 18.7523 9.17765 19.4147 9.83186C20.0772 10.4861 20.9155 10.9266 21.8213 11.1136C22.7271 11.3005 23.6871 11.207 24.5388 10.8465C25.4041 10.4994 26.1342 9.89861 26.6615 9.1376C27.1752 8.37659 27.4591 7.46871 27.4591 6.54749C27.4591 5.62626 26.9589 4.13094 26.0801 3.26311C25.2013 2.39529 24.0115 1.9013 22.7542 1.88795L22.7677 1.9013Z"
          fill="#000"
        />
        <path
          fill={`url(#${gradientId})`}
          d="M74.6304 10.6997L73.7787 12.422L83.6483 17.2284L84.5 15.5061L74.6304 10.6997Z"
        />
        <path
          d="M74.6304 10.7264L78.8216 12.7558C80.2682 12.2618 81.5121 11.3005 82.3233 10.0054C83.1345 8.72372 83.459 7.18834 83.2562 5.69302C83.0534 4.19769 82.3233 2.80918 81.2147 1.76779C80.0925 0.739755 78.6459 0.112253 77.1181 0.0187948C75.5903 -0.0746629 74.0761 0.352573 72.8187 1.23375C71.5749 2.11492 70.6826 3.39663 70.2905 4.86525C69.8984 6.33387 70.0336 7.8826 70.6691 9.25776C71.3045 10.6329 72.4131 11.7544 73.7787 12.422L74.6304 10.713V10.7264ZM72.4943 4.50477C72.8999 3.677 73.5488 2.99609 74.36 2.54215C75.1712 2.08822 76.0906 1.8746 77.0235 1.928C77.9563 1.98141 78.8351 2.31519 79.5787 2.87593C80.3223 3.43668 80.8767 4.19769 81.1741 5.06551C81.4715 5.93334 81.4986 6.86791 81.2687 7.76244C81.0254 8.64361 80.5251 9.44468 79.8356 10.0455C79.1326 10.6463 78.2673 11.0335 77.3479 11.1536C76.4286 11.2738 75.4957 11.1269 74.6575 10.713C73.5353 10.1656 72.6835 9.20436 72.2915 8.04281C71.8859 6.88126 71.967 5.59956 72.5213 4.49142H72.4943V4.50477Z"
          fill="#000"
        />
        <path
          d="M10.7079 0.165657L7.13857 12.0748L3.93434 1.39396C3.7721 0.966723 3.44762 0.606244 3.05554 0.379275C2.64994 0.152306 2.17674 0.0588481 1.71706 0.138955C1.25738 0.20571 0.838255 0.432679 0.527295 0.779808C0.202815 1.12694 0.0270553 1.56752 1.52588e-05 2.02146V12.9293H1.93338V2.02146C1.93338 2.00811 1.96042 1.99476 1.97394 1.98141C1.98746 1.98141 2.0145 1.96806 2.02802 1.96806C2.04154 1.96806 2.06858 1.96806 2.0821 1.98141C2.09562 1.98141 2.10914 2.00811 2.12266 2.02146L5.34042 12.9293H8.86913L12.3303 1.3005V12.9293H14.2636V0.165657H10.6943H10.7079Z"
          fill="#000"
        />
      </svg>
    </span>
  );
};

const MoneliqInvertedLogoIcon: FC<SVGIconType> = ({ color, size = 120 }) => {
  const uid = useId();

  const gradientId = `moneliq-inverted-gradient-${uid.replace(/:/g, '')}`;

  const colorClasses = css({
    color: color || 'rgba(255, 255, 255, 1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  return (
    <span data-testid="moneliq-inverted-logo-icon" className={colorClasses}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        viewBox="0 0 85 18"
        fill="none"
      >
        <defs>
          <linearGradient
            id={gradientId}
            x1="0.07"
            y1="0.13"
            x2="0.95"
            y2="0.91"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#fff" />
            <stop offset="0.5" stopColor="#fff" />
            <stop offset="1" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M68.2219 12.9293H66.1804V0.165657H68.2219V12.9293Z"
          fill="#fff"
        />
        <path
          d="M33.1916 2.24843C33.1916 2.18167 33.2322 2.10157 33.2727 2.04816C33.3268 1.99476 33.3809 1.95471 33.462 1.94135C33.5296 1.928 33.6107 1.94135 33.6783 1.96806C33.7459 1.99476 33.8 2.04816 33.8406 2.11492L38.3968 12.916H42.1824V0.165657H40.2491V12.3686L35.5982 1.40731C35.4359 0.993426 35.1385 0.632946 34.7735 0.392626C34.3949 0.138955 33.9623 0.0054437 33.5026 0.0054437C33.0429 0.0054437 32.3128 0.245764 31.8937 0.659648C31.4611 1.08688 31.2312 1.66098 31.2312 2.24843V12.9293H33.1916V2.24843Z"
          fill="#fff"
        />
        <path
          d="M58.2171 10.9667C58.1225 10.9267 58.0279 10.8732 57.9603 10.7931C57.8791 10.713 57.8251 10.6329 57.7845 10.5261C57.7439 10.4327 57.7304 10.3259 57.7304 10.219V0.165657H55.7971V10.219C55.7971 10.5795 55.8647 10.9267 55.9999 11.2604C56.1351 11.5942 56.3379 11.8879 56.5947 12.1416C56.8516 12.3953 57.1491 12.5955 57.4871 12.7291C57.8251 12.8626 58.1766 12.9293 58.5416 12.9293H64.3687V11.0201C64.3687 11.0201 58.3253 11.0201 58.2307 10.9667H58.2171Z"
          fill="#fff"
        />
        <path
          d="M53.2418 2.11492V0.165657H44.6701V10.219C44.6701 10.94 44.954 11.6209 45.4678 12.1283C45.9815 12.6356 46.6846 12.916 47.4011 12.916H53.2147V11.0068H47.4011C47.1848 11.0068 46.982 10.9267 46.8333 10.7798C46.6846 10.6329 46.5899 10.4327 46.5899 10.219V7.49541H53.2283V5.58621H46.5899V2.11492H53.2418Z"
          fill="#fff"
        />
        <path
          d="M22.7677 13.1029C21.4563 13.1029 20.1719 12.7157 19.0767 12.0081C17.9816 11.2871 17.1299 10.2591 16.6296 9.07085C16.1294 7.86925 15.9942 6.54749 16.2511 5.27913C16.5079 4.01078 17.1434 2.83588 18.0627 1.91465C18.9956 0.993426 20.1719 0.379275 21.4698 0.125604C22.7542 -0.128067 24.0927 0.0054437 25.3095 0.499435C26.5263 0.993426 27.5538 1.83455 28.2839 2.91599C29.0139 3.99743 29.406 5.26578 29.3925 6.56084C29.3925 8.29648 28.6895 9.96537 27.4456 11.1803C26.2018 12.4086 24.5118 13.1029 22.7677 13.1029ZM22.7677 1.9013C21.8348 1.9013 20.929 2.16832 20.1448 2.67567C19.3742 3.18301 18.7658 3.91732 18.4007 4.75844C18.0357 5.61291 17.9411 6.54749 18.1303 7.44201C18.3061 8.34989 18.7523 9.17765 19.4147 9.83186C20.0772 10.4861 20.9155 10.9266 21.8213 11.1136C22.7271 11.3005 23.6871 11.207 24.5388 10.8465C25.4041 10.4994 26.1342 9.89861 26.6615 9.1376C27.1752 8.37659 27.4591 7.46871 27.4591 6.54749C27.4591 5.62626 26.9589 4.13094 26.0801 3.26311C25.2013 2.39529 24.0115 1.9013 22.7542 1.88795L22.7677 1.9013Z"
          fill="#fff"
        />
        <path
          fill={`url(#${gradientId})`}
          d="M74.6304 10.6997L73.7787 12.422L83.6483 17.2284L84.5 15.5061L74.6304 10.6997Z"
        />
        <path
          d="M74.6304 10.7264L78.8216 12.7558C80.2682 12.2618 81.5121 11.3005 82.3233 10.0054C83.1345 8.72372 83.459 7.18834 83.2562 5.69302C83.0534 4.19769 82.3233 2.80918 81.2147 1.76779C80.0925 0.739755 78.6459 0.112253 77.1181 0.0187948C75.5903 -0.0746629 74.0761 0.352573 72.8187 1.23375C71.5749 2.11492 70.6826 3.39663 70.2905 4.86525C69.8984 6.33387 70.0336 7.8826 70.6691 9.25776C71.3045 10.6329 72.4131 11.7544 73.7787 12.422L74.6304 10.713V10.7264ZM72.4943 4.50477C72.8999 3.677 73.5488 2.99609 74.36 2.54215C75.1712 2.08822 76.0906 1.8746 77.0235 1.928C77.9563 1.98141 78.8351 2.31519 79.5787 2.87593C80.3223 3.43668 80.8767 4.19769 81.1741 5.06551C81.4715 5.93334 81.4986 6.86791 81.2687 7.76244C81.0254 8.64361 80.5251 9.44468 79.8356 10.0455C79.1326 10.6463 78.2673 11.0335 77.3479 11.1536C76.4286 11.2738 75.4957 11.1269 74.6575 10.713C73.5353 10.1656 72.6835 9.20436 72.2915 8.04281C71.8859 6.88126 71.967 5.59956 72.5213 4.49142H72.4943V4.50477Z"
          fill="#fff"
        />
        <path
          d="M10.7079 0.165657L7.13857 12.0748L3.93434 1.39396C3.7721 0.966723 3.44762 0.606244 3.05554 0.379275C2.64994 0.152306 2.17674 0.0588481 1.71706 0.138955C1.25738 0.20571 0.838255 0.432679 0.527295 0.779808C0.202815 1.12694 0.0270553 1.56752 1.52588e-05 2.02146V12.9293H1.93338V2.02146C1.93338 2.00811 1.96042 1.99476 1.97394 1.98141C1.98746 1.98141 2.0145 1.96806 2.02802 1.96806C2.04154 1.96806 2.06858 1.96806 2.0821 1.98141C2.09562 1.98141 2.10914 2.00811 2.12266 2.02146L5.34042 12.9293H8.86913L12.3303 1.3005V12.9293H14.2636V0.165657H10.6943H10.7079Z"
          fill="#fff"
        />
      </svg>
    </span>
  );
};

export { MoneliqLogoIcon, MoneliqInvertedLogoIcon };
